export default "__VITE_ASSET__vJ$himNK__"